import React from "react";
import PropTypes from "prop-types";
import Draggable from "react-draggable";
import { Card, ModalBody, ModalHeader } from "reactstrap";
import TooltipButton from "../../../ui/tooltip-button";
import { usePageView } from "../../../../utils/google-analytics-handler";

const OriginsRow = ({ item }) => {
  const { name, value } = item;
  return (
    <div className="d-flex origin-item">
      <div className="col-sm-6 origin-title d-flex align-items-center">
        <span>{name}</span>
      </div>
      <div className="col-sm-6 origin-description d-flex align-items-center">
        <span>{value}</span>
      </div>
    </div>
  );
};
OriginsRow.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  }).isRequired
};
const Origins = ({ isVisible, toggle, origins, rules }) => {
  const visibleClassName = !isVisible ? "invisible" : "";
  const closeButton = (
    <TooltipButton
      buttonText="x"
      tooltipText="Cerrar ventana"
      buttonClassName="close"
      onClick={toggle}
    />
  );
  const originRows = origins.sort().map(x => <OriginsRow key={x.name} item={x} />);
  const rulesRows = rules.map(x => <OriginsRow key={x.name} item={x} />);
  usePageView("/modal/algorithm-information");
  return (
    <Draggable positionOffset={{ x: "-50%", y: "100%" }} handle="#dragable">
      <div className={["row origin-container", visibleClassName]}>
        <div className="col no-margins">
          <ModalHeader
            id="dragable"
            close={closeButton}
            className="modal-header modal-title d-flex align-items-center justify-content-between"
          >
            <h3>INFORMACIÓN DEL ALGORITMO</h3>
          </ModalHeader>
          <ModalBody>
            <Card>{originRows || "No hay información sobre los campos origin."}</Card>
            <h3 className="rules-title">REGLA APLICADA</h3>
            <Card>{rulesRows.length ? rulesRows : "No hay información sobre la regla."}</Card>
          </ModalBody>
          <div className="origin-footer">
            <TooltipButton
              buttonClassName="btn cp-btn cp-btn__medium"
              buttonText="Cerrar"
              buttonTextClassName=""
              tooltipText="Cerrar ventana"
              onClick={toggle}
            />
          </div>
        </div>
      </div>
    </Draggable>
  );
};

Origins.propTypes = {
  isVisible: PropTypes.bool,
  toggle: PropTypes.func,
  origins: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      original: PropTypes.string
    })
  ),
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    })
  )
};

Origins.defaultProps = {
  isVisible: false,
  toggle: () => {},
  origins: [],
  rules: []
};

export default Origins;
